/* eslint-disable simple-import-sort/imports */
import type {
    ButtonItem,
    IndependentAction,
    HighLightConditions,
    RecordLikeProtocol,
    RichTextContentProtocol,
    TableRowHeightProtocol,
    TableViewOptions,
    ViewField,
    ActorEvent
} from '@lighthouse/core'
import React from 'react'

import { TableContent } from './TableContent'

interface TableContainerProps {
    recordOperatorActions?: ButtonItem[]
    checkable?: boolean
    isMobile?: boolean
    viewFields: ViewField[]
    scrollRef: React.RefObject<HTMLDivElement>
    selectedRecords?: string[]
    highLightRules?: HighLightConditions
    blockWidth?: number
    tableRowHeight?: TableRowHeightProtocol
    designConfig: TableViewOptions
    onRecordSelect?: (recordIds: string[]) => void
    onRecordOperatorActionTrigger?: (id: string, actorEvent: ActorEvent, record?: RecordLikeProtocol) => Promise<void>
    onRecordClick?: (id: string, actorEvent: ActorEvent, record: RecordLikeProtocol) => Promise<void>
    recordClickable?: boolean
    onRenderButtonTitle: (v: RichTextContentProtocol, record?: RecordLikeProtocol) => string
}

export const TableContainer: React.FC<TableContainerProps> = ({
    recordOperatorActions,
    checkable,
    isMobile,
    viewFields,
    scrollRef,
    selectedRecords,
    highLightRules = [],
    blockWidth,
    tableRowHeight,
    designConfig,
    onRecordSelect,
    onRecordOperatorActionTrigger,
    onRecordClick,
    onRenderButtonTitle,
    recordClickable
}) => {
    if (!blockWidth || !scrollRef) {
        return null
    }
    return (
        <TableContent
            recordOperatorActions={recordOperatorActions}
            checkable={checkable}
            isMobile={isMobile}
            viewFields={viewFields}
            scrollRef={scrollRef}
            blockWidth={blockWidth}
            selectedRecords={selectedRecords}
            highLightRules={highLightRules}
            tableRowHeight={tableRowHeight}
            designConfig={designConfig}
            onRecordSelect={onRecordSelect}
            onRecordOperatorActionTrigger={onRecordOperatorActionTrigger}
            onRecordClick={onRecordClick}
            onRenderButtonTitle={onRenderButtonTitle}
            recordClickable={recordClickable}
        />
    )
}
